import type { ProgressRow } from '@/stores/progress.store'

const XP_PER_LEVEL = 500

export function computeLevel(totalXp: number) {
  const level = Math.floor(totalXp / XP_PER_LEVEL) + 1
  const xpInLevel = totalXp % XP_PER_LEVEL
  return {
    level,
    xpInLevel,
    xpToNextLevel: XP_PER_LEVEL,
    xpProgress: xpInLevel / XP_PER_LEVEL,
  }
}

export function computeTotalXp(progressMap: Record<string, ProgressRow>): number {
  return Object.values(progressMap).reduce((sum, p) => sum + (p.xp_earned ?? 0), 0)
}

export function computeStreak(progressMap: Record<string, ProgressRow>): number {
  const DAY_MS = 86_400_000

  const dayTimestamps = Object.values(progressMap)
    .filter((p) => p.completed_at)
    .map((p) => {
      const d = new Date(p.completed_at!)
      d.setHours(0, 0, 0, 0)
      return d.getTime()
    })

  const unique = [...new Set(dayTimestamps)].sort((a, b) => b - a)
  if (unique.length === 0) return 0

  const todayStart = (() => {
    const d = new Date()
    d.setHours(0, 0, 0, 0)
    return d.getTime()
  })()

  // Streak must include today or yesterday to still be active
  if (unique[0] !== todayStart && unique[0] !== todayStart - DAY_MS) return 0

  let streak = 1
  for (let i = 1; i < unique.length; i++) {
    if (unique[i - 1] - unique[i] === DAY_MS) {
      streak++
    } else {
      break
    }
  }
  return streak
}
